// Generated by scripts/build-ui-icons.mjs.
export { UploadSimple as default } from "../ui/glyphs-7";
